import { render } from "./academyData.vue?vue&type=template&id=ac0c9ee8&scoped=true"
import script from "./academyData.vue?vue&type=script&lang=js"
export * from "./academyData.vue?vue&type=script&lang=js"

import "./academyData.vue?vue&type=style&index=0&id=ac0c9ee8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0c9ee8"]])

export default __exports__